import { Reader, Writer } from "protobufjs/minimal";
import type { SortOptions } from "../../../../aysa_api/entities/filters/v1/sort_options.types";

export const decodeSortOptions = (reader: Reader): SortOptions => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    case 5:
      return 5;
    default:
      return 0;
  }
};

export const encodeSortOptions = (
  writer: Writer,
  value: SortOptions
): Writer => {
  return writer.int32(value);
};
